var _SizeSemantics;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var Sizes = {
  Small: 12,
  Medium: 16,
  Large: 24,
  // TODO(lindsey-menges): deprecate XLarge size in v7
  XLarge: 32
};
export var SizeSemantics = (_SizeSemantics = {}, _defineProperty(_SizeSemantics, Sizes.Small, 'ButtonSmall'), _defineProperty(_SizeSemantics, Sizes.Medium, 'ButtonMedium'), _defineProperty(_SizeSemantics, Sizes.Large, 'ButtonLarge'), _defineProperty(_SizeSemantics, Sizes.XLarge, 'ButtonLarge'), _SizeSemantics);
export var Types = {
  Primary: 'BUTTON/PRIMARY',
  Secondary: 'BUTTON/SECONDARY',
  Tertiary: 'BUTTON/TERTIARY',
  Full: 'BUTTON/FULL',
  FlatPrimary: 'BUTTON/FLAT_PRIMARY',
  FlatSecondary: 'BUTTON/FLAT_SECONDARY',
  Plain: 'BUTTON/PLAIN',
  Destructive: 'BUTTON/DESTRUCTIVE',
  Link: 'BUTTON/LINK',
  // TODO(lindsey-menges): deprecate Pill types in v7
  PrimaryPill: 'BUTTON/PRIMARY_PILL',
  SecondaryPill: 'BUTTON/SECONDARY_PILL',
  TertiaryPill: 'BUTTON/TERTIARY_PILL'
};
export var States = {
  Default: 'BUTTON/DEFAULT',
  Loading: 'BUTTON/LOADING',
  Success: 'BUTTON/SUCCESS',
  Error: 'BUTTON/ERROR'
};
export var Padding = {
  None: 'BUTTON/PADDING/NONE',
  Default: 'BUTTON/PADDING/DEFAULT',
  Wide: 'BUTTON/PADDING/WIDE'
};